import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const field = "w-full rounded-xl bg-white/5 border border-white/15 px-4 py-3.5 text-white outline-none focus:border-[var(--sun)] transition-colors";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[var(--ink)] grid place-items-center px-5 relative overflow-hidden">
      <div className="hero-grid absolute inset-0" aria-hidden />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-2xl bg-[var(--surface)] border border-white/10 p-8 sm:p-10">
        <Link to="/" data-testid="admin-login-home"><img src="/images/logo-light.png" alt="Carwash Solar + Batteries" className="h-16 w-auto" /></Link>
        <p className="mt-8 eyebrow"><Lock size={12} /> Staff only</p>
        <h1 className="mt-3 font-display font-black uppercase text-5xl">Leads dashboard</h1>
        <label className="mt-8 block font-mono text-[11px] tracking-[0.2em] uppercase text-slate-300 mb-2" htmlFor="a-email">Email</label>
        <input id="a-email" type="email" required data-testid="admin-login-input-email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
        <label className="mt-5 block font-mono text-[11px] tracking-[0.2em] uppercase text-slate-300 mb-2" htmlFor="a-pass">Password</label>
        <input id="a-pass" type="password" required data-testid="admin-login-input-password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="mt-8 w-full flex items-center justify-center gap-2 rounded-full bg-[var(--sun)] text-[var(--ink)] py-4 font-display font-bold uppercase tracking-wider text-lg hover:bg-[var(--sun-deep)] transition-colors disabled:opacity-70">
          {loading && <Loader2 className="animate-spin" size={18} />} Sign in
        </button>
      </form>
    </div>
  );
}
